var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4838_2494)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.325C0 21.625 0.458333 22.725 1.375 23.625C2.29167 24.525 3.4 24.9833 4.7 25H20.325C21.6083 25 22.7083 24.5417 23.625 23.625C24.5417 22.7083 25 21.6083 25 20.325V4.7C25 3.4 24.5417 2.29167 23.625 1.375C22.7083 0.458333 21.6083 0 20.325 0H4.7C3.4 0 2.29167 0.458333 1.375 1.375C0.458333 2.29167 0 3.4 0 4.7V7.825H3.125V4.7C3.125 4.26667 3.275 3.9 3.575 3.6C3.875 3.3 4.25 3.14167 4.7 3.125H20.325C20.7417 3.125 21.1083 3.28333 21.425 3.6C21.7417 3.91667 21.8917 4.28333 21.875 4.7V20.325C21.875 20.7583 21.725 21.125 21.425 21.425C21.125 21.725 20.7583 21.875 20.325 21.875H4.7C4.26667 21.875 3.89167 21.725 3.575 21.425C3.25833 21.125 3.10833 20.7583 3.125 20.325V17.2H0L0 20.325ZM0 14.075H6.25V17.2L12.5 12.5L6.25 7.825V10.95H0V14.075Z",
    fill: "#399E79"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4838_2494"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/checkIn.f18c1e735bae7202348549db13cc432d.svg";
export { ForwardRef as ReactComponent };